import * as angular from "angular";
import {IController, ILogService} from "angular";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ContentTemplateModel} from "../../models/content-template.model";
import {ContentTemplatesService} from "../../services/content-templates.service";
import {$contentTemplates} from "../../$content-templates.factory";
import {ContentTemplateType} from "../../types/content-template-type.type";

export class ContentTemplatesViewComponent implements IController {

  private contentTemplatesRef: any;
  private loadLimit: any;
  public infiniteScroll: any;
  public queryString: string;
  public isCreate: boolean = false;
  public templateToEdit: ContentTemplateModel;


  constructor(private confirmDialogService: ConfirmDialogService, private $log: ILogService,
              private contentTemplatesService: ContentTemplatesService, private $contentTemplates: $contentTemplates,
              private $infiniteScroll) {
  }

  $onInit() {
    this.contentTemplatesRef = this.$contentTemplates();
    this.loadLimit = 20;

    this.contentTemplatesRef.$query({});

    this.infiniteScroll = this.$infiniteScroll(this.contentTemplatesRef, this.loadLimit, {getFullData: true});
  }

  onAddTemplate() {
    this.isCreate = true;
  }

  onChangeQuery(query: string) {
  }

  onEditTemplate(template: ContentTemplateModel) {
    this.templateToEdit = template;
  }

  onCancelCreate() {
    this.isCreate = false;
  }

  onCancelEdit() {
    this.templateToEdit = undefined;
  }

  createTemplate(template: ContentTemplateModel) {
    const templateCopy = angular.copy(template);
    templateCopy.type = ContentTemplateType.Pulled;
    this.contentTemplatesService.createTemplate(templateCopy)
      .then((template: ContentTemplateModel) => {
        this.isCreate = false;
        this._reloadQuery();
      })
  }

  editTemplate(template: ContentTemplateModel) {
    this.contentTemplatesService.editTemplate(template.id, template)
      .then((template: ContentTemplateModel) => {
        this._reloadQuery();
        this.templateToEdit = undefined;
      })
  }

  onDeleteTemplate(template: ContentTemplateModel) {
    const text = 'Are you sure you want to proceed with deleting this template? Doing so will remove its usage from some system triggers.';
    this.confirmDialogService.confirm('Delete Template', text)
      .then(() => {
        this.contentTemplatesService.deleteTemplate(template.id)
          .then(() => {
            this._reloadQuery();
          })
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  private _reloadQuery() {
    this.contentTemplatesRef.$query({})
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }

}

angular
  .module('bringoz.admin.content-templates')
  .component('contentTemplatesView', {
    bindings: {},
    template: require('./content-templates-view.html').default,
    controller: ContentTemplatesViewComponent
  });
